import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_close-thin",
  "use": "icon_close-thin-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_close-thin\"><path d=\"M16 16.9947L8.99471 24L8 23.0053L15.0053 15.9999L8.00011 8.99472L8.99482 8L16 15.0052L23.0052 8L23.9999 8.99472L16.9947 15.9999L24 23.0053L23.0053 24L16 16.9947Z\" fill=\"#DC0B0B\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol